"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AsherFooter_1 = require("./../AsherFooter");
var AsherHeader_1 = require("./../AsherHeader");
var styles = __importStar(require("./../../Common.module.css"));
var revision = {
    CA: "08-1-2023",
    NV: "08-1-2023",
    TX: "08-1-2023",
    TX_ECPP: "08-1-2023"
};
function AsherPage(props) {
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: props.classNameWrap + " " + styles.breakPage },
            react_1.default.createElement(AsherHeader_1.AsherHeader, { state: props.state }),
            props.children,
            react_1.default.createElement(AsherFooter_1.AsherFooter, { nextInputId: props.nextInputId, pageNumber: props.pageNumber, totalPages: props.totalPages, revision: revision[props.state] })),
        !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
}
exports.AsherPage = AsherPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXNoZXJQYWdlLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2Zvcm1zL2FzaGVyL0NvbW1vbi9wYXJ0cy9Bc2hlclBhZ2UvQXNoZXJQYWdlLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsZ0RBQXlCO0FBQ3pCLGdEQUE0QztBQUM1QyxnREFBNEM7QUFDNUMsZ0VBQW1EO0FBRW5ELElBQU0sUUFBUSxHQUFHO0lBQ2IsRUFBRSxFQUFFLFdBQVc7SUFDZixFQUFFLEVBQUUsV0FBVztJQUNmLEVBQUUsRUFBRSxXQUFXO0lBQ2YsT0FBTyxFQUFFLFdBQVc7Q0FDdkIsQ0FBQTtBQUNELFNBQWdCLFNBQVMsQ0FBQyxLQUFLO0lBQzNCLElBQUksS0FBSyxHQUFHLEtBQUssQ0FBQTtJQUVqQixJQUFJLE1BQU0sQ0FBQyxLQUFLLEVBQUU7UUFDZCxLQUFLLEdBQUcsSUFBSSxDQUFBO0tBQ2Y7SUFFRCxPQUFPLENBQ0gsOEJBQUMsZUFBSyxDQUFDLFFBQVE7UUFDWCx1Q0FBSyxTQUFTLEVBQUssS0FBSyxDQUFDLGFBQWEsU0FBSSxNQUFNLENBQUMsU0FBVztZQUN4RCw4QkFBQyx5QkFBVyxJQUFDLEtBQUssRUFBRSxLQUFLLENBQUMsS0FBSyxHQUFJO1lBQ2xDLEtBQUssQ0FBQyxRQUFRO1lBQ2YsOEJBQUMseUJBQVcsSUFDUixXQUFXLEVBQUUsS0FBSyxDQUFDLFdBQVcsRUFDOUIsVUFBVSxFQUFFLEtBQUssQ0FBQyxVQUFVLEVBQzVCLFVBQVUsRUFBRSxLQUFLLENBQUMsVUFBVSxFQUM1QixRQUFRLEVBQUUsUUFBUSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsR0FDakMsQ0FDQTtRQUNMLENBQUMsS0FBSyxJQUFJLHVDQUFLLFNBQVMsRUFBRSxlQUFhLE1BQU0sQ0FBQyxXQUFhLEdBQVEsQ0FDdkQsQ0FDcEIsQ0FBQTtBQUNMLENBQUM7QUF0QkQsOEJBc0JDIn0=